export enum SwipedEventEnums {
    SwipedDown = 'swiped-down',
    SwipedUp = 'swiped-up',
    SwipedLeft = 'swiped-left',
    SwipedRight = 'swiped-right'
}